// @ts-strict-ignore
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IOperation } from '@shared/undo/operation/i-operation';
import { UndoRedoManager } from '@shared/undo/undo-redo.manager';
import { BsModalRef } from 'ngx-bootstrap/modal';

enum undoRedoOperationType {
  UNDO = 'undo',
  REDO = 'redo',
}

@Component({
  standalone: false,
  selector: 'app-undo-redo-history',
  templateUrl: './undo-redo-history.component.html',
})
export class UndoRedoHistoryComponent implements OnInit {
  @Input()
  public operationType: string;

  public undoRedoHistoryDatasource: IOperation[] = [];

  private readonly UNDOREDOHISTORYLIMIT: number = 25;

  constructor(private cdRef: ChangeDetectorRef, private bsModalRef: BsModalRef, private undoRedoManager: UndoRedoManager) {}

  ngOnInit(): void {
    switch (this.operationType) {
      case undoRedoOperationType.UNDO:
        this.undoRedoHistoryDatasource = [...this.undoRedoManager.peekUndos(this.UNDOREDOHISTORYLIMIT)];
        break;
      case undoRedoOperationType.REDO:
        this.undoRedoHistoryDatasource = [...this.undoRedoManager.peekRedos(this.UNDOREDOHISTORYLIMIT)];
        break;
      default:
        break;
    }
    this.undoRedoHistoryDatasource = this.undoRedoHistoryDatasource.reverse();
  }

  protected async selectOperation(operation: IOperation, index: number): Promise<void> {
    switch (this.operationType) {
      case undoRedoOperationType.UNDO:
        await this.undoRedoManager.undoN(index);
        break;
      case undoRedoOperationType.REDO:
        await this.undoRedoManager.redoN(index);
        break;
      default:
        return;
    }
    this.bsModalRef.hide();
    this.cdRef.detectChanges();
  }

  public getOperationDescription(operation: IOperation): string {
    const description = operation.getOperationDescription();
    return description ? description : 'undoRedoHistory.unnamed_operation';
  }
}
